import { render, staticRenderFns } from "./AddSupplierForm.vue?vue&type=template&id=801977d4&"
import script from "./AddSupplierForm.vue?vue&type=script&lang=js&"
export * from "./AddSupplierForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports